<div class="modal-header">
  <h5 class="modal-title">Chốt số công tơ</h5>
  <button type="button" class="close" (click)="dialogRef.hide()" id="cs-add-new-form-close-form-id">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="card-body mx-3">
  <p>Chốt số công tơ toàn khách hàng theo ngày trong tháng đã cấu hình</p>
  <form [formGroup]="formGroup">
    <dcu-date-picker
      [required]="true"
      label="Hãy chọn tháng"
      formControlName="closingTime"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [bsConfig]="bsConfig"
      [dateInputFormat]="'MM/YYYY'"
      (ngModelChange)="changeDate($event)"
    ></dcu-date-picker>
  </form>
  <i class="text-warning">{{message}}</i>
</div>
<div class="modal-footer">
  <div class="start">
    <button type="button" class="btn btnClose close-button"
            (click)="dialogRef.hide()" id="cs-add-new-form-button-close-id">Hủy
    </button>
  </div>
  <div class="end">
    <button type="button" class="btn btn-primary btnSave save-new-button mr-2"
            (click)="closeDate()">Chốt số
    </button>
  </div>
</div>
